module.exports = __webpack_public_path__ + "img/loader.750fc7f7.gif";